
import './index.css';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../ui/AppIcon';

import RecordSection from '../../view/RecordSection';

const typeKey = 'list-page-header';

const RecordListSection = ({
  error = null,
  slug,
  single,
  header = {},
  data = {},
  canCreateContent = false,
  children
}) => {
  const filtersConfig = header.filters || {};
  const [filtersOpen, setFiltersOpen] = useState(Boolean(filtersConfig.defaultFiltersOpen));
  const hasFilters = Boolean(filtersConfig);

  return (
    <div className="stack">

      <header className={[ 'page-header', typeKey, header.className].filter(Boolean).join(' ')}>

        {error ? <p className="error-text">{error}</p> : null}

        <div className={`${typeKey}-bar`}>

          <div className={`${typeKey}-copy`}>
            <h1 className="page-title">{header.title}</h1>
            {header.subtitle ? <p className="page-subtitle">{header.subtitle}</p> : null}
          </div>

          {(hasFilters || slug || header.actions || canCreateContent) ? (
            <div className={['action-cluster', `${typeKey}-actions`].filter(Boolean).join(' ')}>
              {hasFilters ? (
                <button
                  aria-label={filtersOpen ? 'Hide filters' : 'Show filters'}
                  aria-expanded={filtersOpen}
                  className={['button-secondary', `${typeKey}-filter-toggle`].filter(Boolean).join(' ')}
                  onClick={() => setFiltersOpen((open) => !open)}
                  type="button"
                >
                  <FilterIcon />
                  <span className="sr-only">{filtersOpen ? 'Hide filters' : 'Show filters'}</span>
                </button>
              ) : null}
              {header.actions}
              {slug && canCreateContent ? (
                <Link className="button-primary" to={`/${slug}/new`}>
                  {single ? `New ${single}` : 'New'}
                </Link>
              ) : null}
            </div>
          ) : null}
        </div>

        {hasFilters && filtersOpen ? (
          <div className={`${typeKey}-filters`}>

            <div className={`${typeKey}-filters-head`}>
              <p className="eyebrow">List Filters</p>
              {filtersConfig.handleResetFilters ? (
                <div className="list-reset-control">
                  <button className="button-secondary" onClick={filtersConfig.handleResetFilters} type="button">
                    Reset filters
                  </button>
                </div>
              ) : null}
            </div>
            <div className="list-controls list-controls-auto">
              {filtersConfig.filters}
            </div>

            <div className={`${typeKey}-filters-head`}>
              <p className="eyebrow">List Focus</p>
              {filtersConfig.handleResetFilters ? (
                <div className="list-reset-control">
                  <button className="button-secondary" onClick={filtersConfig.handleResetFilters} type="button">
                    Reset focus
                  </button>
                </div>
              ) : null}
            </div>
            <div className="list-controls list-controls-auto">
              {filtersConfig.focus}
            </div>

          </div>
        ) : null}
      </header>

      {children}

    </div>
  );
};

export default RecordListSection;